import {
  REQUEST_INITIAL_SERVICE_ERROR,
  REQUEST_INITIAL_SERVICE_LOADING,
  REQUEST_INITIAL_SERVICE_SUCCESS,
} from "../constants/initialServiceConstant";
import {
  axiosMutiRequests,
  configAxiosMutiRequest,
} from "../https/requestsComon";

export const requestInitialService = () =>
  axiosMutiRequests({
    requestsList: [
      configAxiosMutiRequest({
        url: "/api/meta-data",
        method: "GET",
      }),
    ],
    ACTION_LOADING: REQUEST_INITIAL_SERVICE_LOADING,
    ACTION_SUCCESS: REQUEST_INITIAL_SERVICE_SUCCESS,
    ACTION_ERROR: REQUEST_INITIAL_SERVICE_ERROR,
  });
